import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Input = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 22px 4px rgba(0, 0, 0, 0.13);
  border-radius: 10px;
  margin: 20px 10px;
  overflow: hidden;

  & input {
    padding: 15px 10px;
    display: block;
    width: 100%;
    border: none;
  }
`;

const SearchBar = ({ setSearchVal }) => {
  const [query, setQuery] = useState("");

  useEffect(() => {
    const timeOutId = setTimeout(() => setSearchVal(query), 500);
    return () => clearTimeout(timeOutId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <Input>
      <input
        placeholder="Search name"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />
    </Input>
  );
};

export default SearchBar;
